import { createFileRoute } from '@tanstack/react-router';
import { SourcesView } from '~portal/components/admin/automations/sources/SourcesView';
import { useCanWriteSourcePolicy } from '~portal/hooks';

/**
 * @desc Ario → Sources (add-ario-general-purpose-agent task 5.4): the robots policy of each host
 * with a record, the workflows reading it, and Revoke (with a reason) for Operators.
 */
export const Route = createFileRoute('/_protected/admin/ario/sources')({
  component: SourcesPage,
});

function SourcesPage() {
  return <SourcesView canWrite={useCanWriteSourcePolicy()} />;
}
